/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocCheckIcon24Solid = forwardRef('DocCheckIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2h4.05v5.3a2.75 2.75 0 0 0 2.75 2.75H20V18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm8.533 11.585a.875.875 0 1 0-1.3-1.17l-3.62 4.02a.375.375 0 0 1-.543.015L9.5 14.88a.875.875 0 0 0-1.237 1.238l1.568 1.568c.861.861 2.268.824 3.082-.081l3.619-4.02Z" }),
        React.createElement("path", { d: "M20 8.51v.04h-5.2c-.69 0-1.25-.56-1.25-1.25V2.06L20 8.51Z" })));
});
